import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Gegevens from "./views/Gegevens.vue";
import PaginaNietGevonden from "./views/404.vue";

 Vue.use(Router);

 export default new Router({
  base: process.env.VUE_APP_BASE_HREF,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        analyticsIgnore: true
      }      
    },
    {
      path: "/gegevens/:id/",
      name: "gegevens",
      component: Gegevens,
      props: true,
      meta: {
        analyticsIgnore: true
      }      
    },
    { 
     path: "*",
     name: "404",
     component: PaginaNietGevonden 
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});
